
import * as React from "react"
import { isMobileDevice } from "@/utils/wallet-detection";

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    // Check if it's a true mobile device (not just narrow viewport)
    const checkMobile = () => {
      const isActualMobileDevice = isMobileDevice();
      const isNarrowViewport = window.innerWidth < MOBILE_BREAKPOINT;
      
      // Only consider it mobile if it's an actual mobile device
      // OR if narrow viewport AND not desktop Safari
      const userAgent = navigator.userAgent;
      const isDesktopSafari = /Macintosh/.test(userAgent) && /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
      
      // Desktop Safari should never be considered mobile regardless of viewport
      if (isDesktopSafari) {
        return false;
      }
      
      return isActualMobileDevice || isNarrowViewport;
    };

    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(checkMobile());
    }
    
    mql.addEventListener("change", onChange)
    setIsMobile(checkMobile());
    
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}
